import { useRouter } from 'vue-router';
export function usePodcastsRouter() {
    var router = useRouter();
    var show = function () { return router.push({
        name: 'podcast.show',
        params: {},
    }); };
    var edit = function () { return router.push({
        name: 'podcast.edit',
        params: {},
    }); };
    return { show: show, edit: edit };
}
;
